import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import SelectorField from './selector-field';
import './multiple-select-field/result';

Component('tr-multiple-select-field', {
  extends: [SelectorField],

  mixins: [eventListenerMixin],

  properties: {
    multiple: {
      get() { return true; },
    },

    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.nativeField.disabled = this.disabled;
      },
    },
  },

  ready() {
    const selectTrigger = this.result.querySelector('.select-trigger');
    this.list.setAnchor(selectTrigger);
    this.helperText = this.querySelector('.mdc-select-helper-text');

    this.listenTo(this.result, 'tr-multiple-select-field-result:active', () => {
      if (!this.list.isOpen()) this.list.open();
    });

    this.listenTo(this.list, {
      'tr-selector-field-list:beforeOpen': () => {
        const margin = { top: -this.helperText.offsetHeight };
        if (!this.list.appendMenuToBody) {
          Object.assign(margin, { left: selectTrigger.offsetLeft });
        }
        this.list.setAnchorMargin(margin);
      },
    });
  },
});
